import { render, staticRenderFns } from "./CalendarFlightDetails.vue?vue&type=template&id=8377d8e4&scoped=true&"
import script from "./CalendarFlightDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarFlightDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarFlightDetails.vue?vue&type=style&index=0&id=8377d8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8377d8e4",
  null
  
)

export default component.exports